/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IngestionStatusControllerGetDocumentStatsQueryResponse, IngestionStatusControllerGetDocumentStatsQueryParams, IngestionStatusControllerGetDocumentStats403 } from "../../models/documentIngestionStatusController/IngestionStatusControllerGetDocumentStats";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { ingestionStatusControllerGetDocumentStats } from "../../clients/document-ingestion-statusService/ingestionStatusControllerGetDocumentStats";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const ingestionStatusControllerGetDocumentStatsQueryKey = (params: IngestionStatusControllerGetDocumentStatsQueryParams = {}) => [{
  url: '/api/v1/documents/ingestion-status/documents'
}, ...(params ? [params] : [])] as const;
export type IngestionStatusControllerGetDocumentStatsQueryKey = ReturnType<typeof ingestionStatusControllerGetDocumentStatsQueryKey>;
export function ingestionStatusControllerGetDocumentStatsQueryOptions(params?: IngestionStatusControllerGetDocumentStatsQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = ingestionStatusControllerGetDocumentStatsQueryKey(params);
  return queryOptions<IngestionStatusControllerGetDocumentStatsQueryResponse, ResponseErrorConfig<IngestionStatusControllerGetDocumentStats403>, IngestionStatusControllerGetDocumentStatsQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return ingestionStatusControllerGetDocumentStats(params, config);
    }
  });
}

/**
 * @description Returns statistics about document creation and processing, including counts by status, processing step breakdown, and time series data. Requires System Administrator role.
 * @summary Get document ingestion statistics
 * {@link /api/v1/documents/ingestion-status/documents}
 */
export function useIngestionStatusControllerGetDocumentStats<TData = IngestionStatusControllerGetDocumentStatsQueryResponse, TQueryData = IngestionStatusControllerGetDocumentStatsQueryResponse, TQueryKey extends QueryKey = IngestionStatusControllerGetDocumentStatsQueryKey>(params?: IngestionStatusControllerGetDocumentStatsQueryParams, options: {
  query?: Partial<QueryObserverOptions<IngestionStatusControllerGetDocumentStatsQueryResponse, ResponseErrorConfig<IngestionStatusControllerGetDocumentStats403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? ingestionStatusControllerGetDocumentStatsQueryKey(params);
  const query = useQuery({
    ...ingestionStatusControllerGetDocumentStatsQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<IngestionStatusControllerGetDocumentStats403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}